module.exports = __webpack_public_path__ + "img/undraw_mobile_ux_o0e1.bb1f1801.svg";